<div #sidebar class="layout-sidebar" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">
    <div class="p-sidebar-header">
        <a [routerLink]="['/accueil']" class="logo">
            <div class="logo-image w-full">
                 <img [src]="'assets/layout/images/logo-' + logo + '.svg'" alt="diamond-layout" class="footer-logo" />
            </div>
    </a>
    <button class="layout-sidebar-anchor p-link" type="button" (click)="anchor()"></button>
</div>

<div #menuContainer  class="layout-menu-container">
        <app-menu></app-menu>
    </div>
</div>
